/**
 * The bearer credential of the signed-in account, held in memory. The identity module writes it; the API
 * client reads it for the `Authorization` header only. It is never placed in a URL, a log or a cookie.
 */
export class Credentials {
	/**
	 * Stands where a bearer would, for an adapter whose credential the browser holds as an `HttpOnly`
	 * cookie of the service's origin. It is not a credential and proves nothing: the API client reads
	 * it as an instruction to send the cookie and to set no `Authorization` header at all.
	 */
	static readonly COOKIE = '\u0000cookie';

	#token: string | undefined;

	get token() {
		return this.#token;
	}

	get present() {
		return this.#token !== undefined;
	}

	/** Whether the credential lives in a cookie this page cannot read */
	get ambient() {
		return this.#token === Credentials.COOKIE;
	}

	set(token: string) {
		this.#token = token;
	}

	clear() {
		this.#token = undefined;
	}
}
